"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeSelector = void 0;

var _react = _interopRequireWildcard(require("react"));

var _memoizerific = _interopRequireDefault(require("memoizerific"));

var _coreEvents = require("@storybook/core-events");

var _components = require("@storybook/components");

var _constants = require("../constants");

var _shared = require("../shared");

var _ColorIcon = require("./ColorIcon");

var _ThemeStory = require("./ThemeStory");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var iframeId = 'storybook-preview-iframe';
var createThemeSelectorItem = (0, _memoizerific["default"])(1000)(function (id, title, color, hasSwatch, change, active) {
  return {
    id: id,
    title: title,
    onClick: function onClick() {
      change({
        selected: id,
        expanded: false
      });
    },
    value: id,
    right: hasSwatch ? /*#__PURE__*/_react["default"].createElement(_ColorIcon.ColorIcon, {
      background: color
    }) : undefined,
    active: active
  };
});
var getDisplayableState = (0, _memoizerific["default"])(10)(function (props, state, change) {
  var _getConfigFromApi = (0, _shared.getConfigFromApi)(props.api),
      clearable = _getConfigFromApi.clearable,
      list = _getConfigFromApi.list,
      target = _getConfigFromApi.target,
      defaultTheme = _getConfigFromApi["default"];

  var selectedThemeName = (0, _shared.getSelectedThemeName)(list, defaultTheme, state.selected);
  var availableThemeSelectorItems = [];
  var selectedTheme;

  if (selectedThemeName !== 'none' && clearable) {
    availableThemeSelectorItems.push(createThemeSelectorItem('none', 'Clear theme', 'transparent', null, change, false));
  }

  if (list.length) {
    availableThemeSelectorItems = [].concat(_toConsumableArray(availableThemeSelectorItems), _toConsumableArray(list.map(function (_ref) {
      var color = _ref.color,
          name = _ref.name;
      return createThemeSelectorItem(name, name, color, true, change, name === selectedThemeName);
    })));
    selectedTheme = (0, _shared.getSelectedTheme)(list, selectedThemeName);
  }

  return {
    items: availableThemeSelectorItems,
    selectedTheme: selectedTheme,
    themes: list,
    target: target
  };
});

var ThemeSelector = /*#__PURE__*/function (_Component) {
  _inherits(ThemeSelector, _Component);

  var _super = _createSuper(ThemeSelector);

  function ThemeSelector() {
    var _this;

    _classCallCheck(this, ThemeSelector);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));
    _this.state = {
      decorator: false,
      selected: null,
      expanded: false
    };

    _this.setStories = function () {
      return _this.setState({
        selected: null
      });
    };

    _this.setTheme = function (theme) {
      return _this.setState({
        selected: theme
      });
    };

    _this.setDecorator = function () {
      return _this.setState({
        decorator: true
      });
    };

    _this.change = function (args) {
      var selected = args.selected;
      var api = _this.props.api;

      var _getConfigFromApi2 = (0, _shared.getConfigFromApi)(api),
          list = _getConfigFromApi2.list,
          onChange = _getConfigFromApi2.onChange;

      _this.setState(args);

      api.emit(_constants.CHANGE, selected);

      if (typeof onChange === 'function') {
        var selectedTheme = (0, _shared.getSelectedTheme)(list, selected);
        onChange(selectedTheme);
      }
    };

    return _this;
  }

  _createClass(ThemeSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var api = this.props.api;
      api.on(_coreEvents.SET_STORIES, this.setStories);
      api.on(_constants.THEME, this.setTheme);
      api.on(_constants.DECORATOR, this.setDecorator);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var api = this.props.api;
      api.off(_coreEvents.SET_STORIES, this.setStories);
      api.off(_constants.THEME, this.setTheme);
      api.off(_constants.DECORATOR, this.setDecorator);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          decorator = _this$state.decorator,
          expanded = _this$state.expanded;

      var _getDisplayableState = getDisplayableState(this.props, this.state, this.change),
          items = _getDisplayableState.items,
          selectedTheme = _getDisplayableState.selectedTheme,
          target = _getDisplayableState.target,
          themes = _getDisplayableState.themes;

      return items.length ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, !decorator && /*#__PURE__*/_react["default"].createElement(_ThemeStory.ThemeStory, {
        iframeId: iframeId,
        selectedTheme: selectedTheme,
        target: target,
        themes: themes
      }), /*#__PURE__*/_react["default"].createElement(_components.WithTooltip, {
        placement: "top",
        trigger: "click",
        tooltipShown: expanded,
        onVisibilityChange: function onVisibilityChange(newVisibility) {
          return _this2.setState({
            expanded: newVisibility
          });
        },
        tooltip: /*#__PURE__*/_react["default"].createElement(_components.TooltipLinkList, {
          links: items
        }),
        closeOnClick: true
      }, /*#__PURE__*/_react["default"].createElement(_components.IconButton, {
        key: "theme",
        active: selectedTheme,
        title: "Change the theme of the preview"
      }, /*#__PURE__*/_react["default"].createElement(_components.Icons, {
        icon: "photo"
      })))) : null;
    }
  }]);

  return ThemeSelector;
}(_react.Component);

exports.ThemeSelector = ThemeSelector;